import _ from 'lodash';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {getConditionAndDescription, updateCondition} from '../../../store/actions/appraisal.action';
import {CheckAccess, handleToast} from '../../../utils/handler';
import {NumberInput} from '../../components/CommonPages';
import PopupWindow from '../../components/Popup';
interface description {
  UID: string;
  description?: string | undefined;
}
interface conditionType {
  UID: string;
  condition: string;
  type: string;
  description: description[];
}
let exhibitBListInitialValue: conditionType[] = [];
export const DomainCategory: React.FC = (): JSX.Element => {
  const [exhibitBList, setExhibitList] = useState<conditionType[]>(exhibitBListInitialValue);
  const [currentExhibitObj, setCurrentExhibitObj] = useState<conditionType>({condition: '', type: '', description: [{UID: 'string', description: ''}], UID: ''});
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [descriptionDetails, setDescription] = useState<description>({UID: '', description: ''});
  const {t} = useTranslation();

  useEffect(() => {
    loadExhibitList();
  }, []);
  const loadExhibitList = () => {
    getConditionAndDescription('ExhibitB').then((result) => {
      if (result) {
        exhibitBListInitialValue = result;
        setExhibitList(result);
      }
    });
  };
  const saveExhibit = () => {
    if (currentExhibitObj && currentExhibitObj.UID) {
      updateCondition(descriptionDetails.UID, {categoryName: currentExhibitObj.condition, description: descriptionDetails.description}).then((response) => {
        if (response && exhibitBList) {
          let findExhibitIndex = _.findIndex(exhibitBList, ['UID', currentExhibitObj.UID]);
          let newArray: conditionType[] = [...exhibitBList];
          if (findExhibitIndex >= 0) {
            let condition = newArray[findExhibitIndex];
            let findDescriptionIndex = _.findIndex(condition.description, ['UID', descriptionDetails.UID]);
            handleToast({message: response}, 'success');
            if (findDescriptionIndex >= 0) {
              condition.description[findDescriptionIndex] = descriptionDetails;
              setExhibitList(newArray);
              exhibitBListInitialValue = newArray;
            }
          }
          setPopupOpen(false);
        }
      });
    }
  };
  const exhibitDescription = (descriptionArray: description[]) => {
    let description = descriptionArray[0]?.description;
    return description || '';
  };
  return (
    <div className="row">
      {isPopupOpen && (
        <PopupWindow onClose={() => setPopupOpen(false)} header="Edit Percentage">
          <div className="model p-3">
            <div className="content form-group">
              <div className="input-group mb-3">
                <NumberInput placeholder="Exhibit percentage" className="form-control" value={descriptionDetails?.description} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription({...descriptionDetails, description: e.target.value})} />

                {/* <input type="number" className="form-control"
                                    onKeyDown={e => { ([189, 69, 109, 187, 107].includes(e.keyCode)) && e.preventDefault() }}
                                    placeholder="Exhibit percentage"
                                    value={descriptionDetails?.description}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                     setDescription({ ...descriptionDetails, description: e.target.value })} /> */}
                <button className="btn btn-grad normal-btn input-group-text" onClick={() => saveExhibit()}>
                  {' '}
                  Save
                </button>
              </div>
            </div>
          </div>
        </PopupWindow>
      )}
      <div className="col-12">
        {/* <div className="d-flex justify-content-between">
                    <label className="title"><span>{t("Exhibit Category")}</span> </label>
                </div> */}
        <table className="table text-center table table-striped table-hover">
          <thead>
            <tr>
              <th>Category</th>
              <th>Percent</th>
              {CheckAccess('ChangeCategoryValues') && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {_.isArray(exhibitBList) && exhibitBList.length === 0 ? (
              <tr className="text-center">
                <td colSpan={3}>{t('loading...')}</td>
              </tr>
            ) : (
              _.isArray(exhibitBList) &&
              exhibitBList.map((exhibit: conditionType, index: number) => (
                <tr key={index} className="table-row-action">
                  <td>{exhibit.condition}</td>
                  <td>
                    {/* <div className="d-flex justify-content-center"> */}
                    {exhibitDescription(exhibit.description)}
                    {/* </div> */}
                  </td>
                  {CheckAccess('ChangeCategoryValues') && (
                    <td>
                      <div className="">
                        <i
                          className="fas fa-edit c-pointer text-success"
                          onClick={() => {
                            setCurrentExhibitObj(exhibit);
                            setDescription(exhibit.description[0]);
                            setPopupOpen(true);
                          }}
                        ></i>
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DomainCategory;
